// ENTITY fr.gestionpial.user.entities.GestionPialUser generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class GestionPialUser {

  static readonly __ic2_fqn: string = 'fr.gestionpial.user.entities.GestionPialUser';

  idUser: number | null = 0;
  creationDate: Date | null = null;
  lastConnectionDate: Date | null = null;
  facebookId: string | null = '';
  resetPwdToken: string | null = '';
  confirmAccountToken: string | null = '';
  mailConfirmed: boolean | null = false;

  constructor(init?:Partial<GestionPialUser>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.user.entities.GestionPialUser'] = GestionPialUser;

fields['fr.gestionpial.user.entities.GestionPialUser']  = {
    idUser: 'java.lang.Integer',
    creationDate: 'java.time.Instant',
    lastConnectionDate: 'java.time.Instant',
    facebookId: 'java.lang.String',
    resetPwdToken: 'java.lang.String',
    confirmAccountToken: 'java.lang.String',
    mailConfirmed: 'java.lang.Boolean'
};
